import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReactPaginate from "react-paginate";
import { BiEditAlt } from "react-icons/bi";
import { edit } from "brace";
import Swal from "sweetalert2";
import ReactSwitch from 'react-switch'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { apiRequest } from "../../store/allApi";

const $ = require("jquery");
$.Datatable = require("datatables.net");

export default function View() {
  const navigate = useHistory();
  const location = useLocation();
  const path = location.pathname.split("/")[3];
  const [user, setUser] = useState();
  const [item, setVerify] = useState();
  const [challenge, setchallenge] = useState();
  const [txn, setTxn] = useState();
  const [superUser, setSuperUser] = useState(true)
  const [txnwith, setTxnwith] = useState();
  const [referral, setReferral] = useState();
  const [bonus, setBonus] = useState([]);
  const [penalty, setPenlty] = useState([]);
  const [kyc, setKyc] = useState();
  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL;
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const userData = localStorage.getItem("userData");
  const Number = localStorage.getItem("Number");

  let [mismatchValue, setmismatchValue] = useState(0);
  let [HoldBalance, setHoldBalance] = useState(0);

  const getUser = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`get_user/${path}`, "GET", null, headers)
      if (res.data) {
        setUser(res.data);
          setSuperUser(res.data?.superUser);
        Allrefer(res.data.referral_code);
        setmismatchValue(
          res.data.Wallet_balance -
          (res.data.wonAmount -
            res.data.loseAmount +
            res.data.totalDeposit +
            res.data.referral_earning +
            res.data.totalBonus -
            (res.data.totalWithdrawl +
              res.data.referral_wallet +
              res.data.withdraw_holdbalance +
              res.data.hold_balance +
              res.data.totalPenalty))
        );
        setHoldBalance(res.data.hold_balance);

      }
    } catch (e) {
      console.log(e);


    }
    finally {
    }
  };

  const [referCount, setRefercount] = useState([]);
  const Allrefer = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`referral/code/${id}`, "GET", null, headers)
      if (res.data) {
        setRefercount(res.data);
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  };

  const Allchallenge = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`get_challange/user/${path}`, "GET", null, headers)
      if (res) {
        setTxn(undefined);
        setTxnwith(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenlty(undefined);
        setKyc(undefined);
        setchallenge(res?.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };

  const transactionHis = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`txn_history/user/${path}`, "GET", null, headers)
      if (res) {
        setchallenge(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenlty(undefined);
        setKyc(undefined);
        setTxnwith(undefined);
        setTxn(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };
  const withdrawalHis =async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
   
    try {
      const res = await apiRequest(`txnwith_history/user/${path}`, "GET", null, headers)
      if (res) {
            setTxn(undefined);
        setchallenge(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenlty(undefined);
        setKyc(undefined);
        setTxnwith(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const referralHis = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    try {
      const res = await apiRequest(`referral/code/winn/${user.referral_code}`, "GET", null, headers)
      if (res) {
             setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setBonus(undefined);
        setPenlty(undefined);
        setKyc(undefined);
        setReferral(res.data);
        console.log(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };
  const bonusHis = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    try {
      const res = await apiRequest(`bonus_history_admin/user/${path}`, "GET", null, headers)
      if (res) {
                setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setKyc(undefined);
        setReferral(undefined);
        setPenlty(undefined);
        setBonus(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };
  const penaltyHis = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    
    try {
      const res = await apiRequest(`penalty_history_admin/user/${path}`, "GET", null, headers)
      if (res) {
            setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setKyc(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenlty(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };

  // refferal edit
  

  const Referal = () => {
    Swal.fire({
      title: "Enter Referral Code",
      inputValue: user.referral,
      input: "number",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

        try {
          const res = await apiRequest(`user/updaterefferal/${login}/${path}`, "GET", null, headers);

          if (res.status !== 200) {
            throw new Error(res.statusText);
          }

          getUser();
          return res.data; // Axios responses store data in res.data
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.message}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: result.value.msg,
          imageUrl: result.value.avatar_url,
        });
      }
    });
  };

  const ReferalEarning = () => {
    Swal.fire({
      title: "Enter Referral balance",
      inputValue: user.referral_wallet,
      input: "number",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

        try {
          const res = await apiRequest(`user/referralwallet/${login}/${path}`, "GET", null, headers);

          if (res.status !== 200) {
            throw new Error(res.statusText);
          }

          getUser();
          return res.data; // Axios responses store data in res.data
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.message}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: result.value.msg,
          imageUrl: result.value.avatar_url,
        });
      }
    });
  };


  const getKyc =async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    
    try {
      const res = await apiRequest(`admin/user/kyc/${path}`, "GET", null, headers)
      if (res) {
          setTxn(undefined);
      setTxnwith(undefined);
      setReferral(undefined);
      setchallenge(undefined);
      setBonus(undefined);
      setPenlty(undefined);
      setKyc(res.data);
      console.log(res.data);
      $("table").dataTable();
      imageViewer();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };

  function imageViewer() {
    let imgs = document.getElementsByClassName("img"),
      out = document.getElementsByClassName("img-out")[0];
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains("el")) {
        imgs[i].classList.add("el");
        imgs[i].addEventListener("click", lightImage);
        function lightImage() {
          let container = document.getElementsByClassName("img-panel")[i];
          container.classList.toggle("img-panel__selct");
        }

        imgs[i].addEventListener("click", openImage);
        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = document.getElementsByClassName("img-panel")[i];
          container.classList.add("img-panel__selct");
          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);

          setTimeout(function () {
            imgWrapper.classList.add("img-wrapper__initial");
            imgElement.classList.add("img-selected-initial");
          }, 50);

          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }
  const update =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "verified" }, headers)
      if (res) {
           getUser();
        getKyc();
      }
    } catch (e) {
      console.log(e);

    }
    finally {
    }
  };
  const deleteBank = (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .get(baseUrl + `/user-bank-change/${Id}`, { headers })
      .then((res) => {
        getUser();
        console.log(res);
      });
  };
  const updateSuperUser = async (val, reason = "") => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`super-user/${user._id}`, "POST", { superUser: val, reason }, headers);
      if (res) {
        getUser();
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };
  const updateMismatch = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`user/missmatch/clear/${Id}`, "PATCH", null, headers)
      if (res) {
        getUser();
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  };

  const updateHold = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`user/Hold/clear/${Id}`, "PATCH", null, headers)
      if (res) {
        getUser();
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  };

  const handleSaveWithdraw = async () => {
      //  setLoading(true);
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      try {
        const res = await apiRequest(`addmanualwithdraw/${user._id}`, "PATCH", {
          amount: WithdrawAmount,
          reason: WithdrawReason 
        }, headers);
        if (res.data) {
          //  setLoading(false);
          alert("Withdrawal submitted successfully");
          getUser();
          setShowWithdraw(false);
        }
      } catch (e) {
        //  setLoading(false);
        console.log(e);
        alert("Failed to update bank details");
      }
    };

  const checkfailedpayout =async (txn_id, referenceId) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    try {
      const res = await apiRequest(`payout/response/api`, "POST", { txn_id, referenceId }, headers)
      if (res) {
        getUser()
        getUser()
        withdrawalHis()
        const icon = res.data.status == "SUCCESS" ? "success" : "danger";
        const title =
          res.data.status == "SUCCESS"
            ? "Withdraw successfully"
            : "Transaction Proccessing or Failed";
      }
    } catch (e) {
           if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
        }

    }
    finally {
    }
  };

  const deletedata =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "reject" }, headers)
      if (res) {
           getUser();
        getKyc();
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  };

  //   refferal history
  let [limit, setLimit] = useState(10);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [show, setShow] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const openWithdraw = () => setShowWithdraw(true);
  const closeWithdraw = () => setShowWithdraw(false);

  const [WithdrawAmount, setWithdrawAmount] = useState('');
  const [WithdrawReason, setWithdrawReason] = useState('');

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    // setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };

    const chnageSuperUser = async (val) => {
      if (!val) {
        // Prompt for reason when setting to false
        const { value: reason } = await Swal.fire({
          title: 'Reason for disabling Super User',
          input: 'text',
          inputLabel: 'Please provide a reason',
          inputPlaceholder: 'Enter reason here...',
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return 'Reason is required!';
            }
          }
        });

        if (!reason) {
          return; // Cancelled or no reason provided
        }

        setSuperUser(val);
        updateSuperUser(val, reason);
      } else {
        setSuperUser(val);
        updateSuperUser(val);
      }
    };


  // view Refferal History
  function RefferalUser(id) {
    navigate.push(`/user/view_user/${id}`);
    handleClose();
    window.location.reload();
  }

  useEffect(() => {
    getUser();
    Allchallenge();
  }, []);

  return (
    <>
      {Boolean(user) && (
        <>
          <div className="img-out"></div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card shadow-lg h-100 ">
                <div className="card-header">User Details</div>
                <ul className="list-group list-group-flush">
                  {user && user.avatar && (
                    <li className="list-group-item img-panel">
                      Profile Pic :
                      <img
                        className="img"
                        src={baseUrl + `/${user.avatar}`}
                        alt="Profile"
                        style={{
                          borderRadius: "5px",
                          width: "4rem",
                          height: "4rem",
                        }}
                      />{" "}
                    </li>
                  )}
                  <li className="list-group-item">Name : {user?.Name}</li>

                  <li className="list-group-item">
                    verified :{" "}
                    <span
                      className={`badge badge-pill ${user.verified == "verified"
                          ? "badge-success"
                          : "badge-danger"
                        }`}
                    >
                      {user.verified}
                    </span>
                  </li>
                  <li className="list-group-item">
                  {userData == 'Admin' || 
                          Number === "true" ? (
                            <> 
                            Phone : {user.Phone}
                            </>
                          ) : (
                            <>
                            {`${
                               '********' + user.Phone.toString().slice(-2)
                             }`}
                            </>
                          )}
                  </li>

                  <li className="list-group-item">
                    Wallet balance : {user.Wallet_balance}
                  </li>
                  <li className="list-group-item">
                    Withdrawal Amount balance : {user.withdrawAmount}
                  </li>
                  <li className="list-group-item">
                    Withdrawal Hold balance : {user.withdraw_holdbalance}
                    <div class="col" style={{ color: "#8c8c8c" }}>
                      Note: If hold balance not 0 user can't make new Withdrawal
                      request
                    </div>
                  </li>
                  <li className="list-group-item">
                    Referral balance : {user.referral_wallet}
                    
                  </li>
                  <li className="list-group-item">
                    Referral count : {referCount && referCount}
                  </li>
                  <li className="list-group-item">
                    Referral earning : {user.referral_earning}
                  </li>
                  <li className="list-group-item">
                    total Deposit : {user.totalDeposit}
                  </li>
                  <li className="list-group-item">
                    total Withdrawal : {user.totalWithdrawl}
                  </li>
                  <li className="list-group-item">
                    total Bonus : {user.totalBonus}
                  </li>
                  <li className="list-group-item">
                    total Penalty : {user.totalPenalty}
                  </li>
                  <li className="list-group-item">
                    hold balance : {HoldBalance}
                  </li>
                  <li className="list-group-item">
                    Won amount : {user.wonAmount}
                  </li>
                  <li className="list-group-item">
                    Lose amount : {user.loseAmount}
                  </li>
                  <li className="list-group-item">
                    Calculated wallet balance :{" "}
                    {user.wonAmount -
                      user.loseAmount +
                      user.totalDeposit +
                      user.referral_earning +
                      user.totalBonus -
                      (user.totalWithdrawl +
                        user.referral_wallet +
                        user.withdraw_holdbalance +
                        user.hold_balance +
                        user.totalPenalty)}
                  </li>
                  <li className="list-group-item">
                    Mismatch wallet balance : {mismatchValue}
                  </li>
                  <li className="list-group-item">
                    {" "}
                    Referral code : {user.referral_code}
                    {/* {admindata?.user?.usertype == "Admin" ? ( */}
                    <span style={{ marginLeft: "16px", fontSize: "16px" }}>
                      {userData === "Admin" ? <FaEye onClick={handleShow} /> : ""}
                    </span>
                    {/* ) : (
                      ""
                    )} */}
                  </li>
                  <li className="list-group-item">
                    Referral by : {user.referral}
                    <span style={{ marginLeft: "16px", fontSize: "16px" }}>
                      {userData === "Admin" ? <BiEditAlt onClick={Referal} /> : ""}
                    </span>
                  </li>

                  <li className="list-group-item">
                    Account created at :{" "}
                    {dateFormat(user.createdAt).split(",")[0]}
                  </li>
                  <li className="list-group-item">
                    Account updated at :{" "}
                    {dateFormat(user.updatedAt).split(",")[0]}
                  </li>
                  <li
  className={`list-group-item ${user?.user_type === "Block"  ? "bg-danger text-white" : ""}`}
>
  User Type : {user?.user_type}
</li>

                  <li className="list-group-item">
                    Last Msg :  {user?.lastmsg}
                  </li>
                </ul>
              </div>
            </div>
            {userData == "Admin" ? (
            <div className="col-lg-6 mb-4">
              <div className="card shadow-lg h-100 ">
                <div className="card-header">Bank Details</div>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Account holder name : {user.holder_name}
                  </li>
                  <li className="list-group-item">
                    IFSC code : {user.ifsc_code}
                  </li>
                  <li className="list-group-item">
                    Account number : {user.account_number}
                  </li>
                  <li className="list-group-item">
                    Account Delete :  <button
                      onClick={() => deleteBank(user._id)}
                      className="btn btn-danger"
                    >
                       Delete
                    </button>
                  </li>
                  <li className="list-group-item">UPI ID : {user.upi_id}
                    { userData.user_type == 'Admin' ? (
                        <button
                          onClick={() => openWithdraw(true)}
                          className="btn btn-primary"
                        >
                         Add withdraw
                        </button>
                        ) : ""}
                  </li>
                </ul>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Mismatch:{" "}
                    <button
                      onClick={() => updateMismatch(user._id)}
                      className="btn btn-success"
                    >
                      CLEAR ({mismatchValue})
                    </button>
                  </li>
                  <li className="list-group-item">
                    Hold :{" "}
                    <button
                      onClick={() => updateHold(user._id)}
                      className="btn btn-success"
                    >
                      CLEAR ({HoldBalance})
                    </button>{" "}
                  </li>

                      <li className="list-group-item">
                      <Row style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Super User</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={superUser}
                            onChange={chnageSuperUser}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>
                  </li>

                </ul>
              </div>
            </div> ) : ""}
          </div>

          <div className="row ">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <button
                    className={
                      Boolean(challenge)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={Allchallenge}
                  >
                    Game History
                  </button>

                  <button
                    className={
                      Boolean(txn)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={transactionHis}
                  >
                    Deposit History
                  </button>
                  <button
                    className={
                      Boolean(txnwith)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={withdrawalHis}
                  >
                    withdrawal History
                  </button>
                  <button
                    className={
                      Boolean(referral)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={referralHis}
                  >
                    Referral History
                  </button>
                  <button
                    className={
                      Boolean(bonus)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={bonusHis}
                  >
                    Bonus History
                  </button>
                  <button
                    className={
                      Boolean(penalty)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={penaltyHis}
                  >
                    Penalty History
                  </button>
                  <button
                    className={
                      Boolean(kyc)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={getKyc}
                  >
                    KYC
                  </button>
                  {Boolean(challenge) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Creator</th>
                            <th> Accepter</th>
                            <th> Amount </th>
                            <th> Win/Lose Amt </th>
                            <th> closing balance</th>
                            <th> Status </th>
                            <th> Game Type </th>
                            <th> Winner </th>
                            <th> Date </th>
                            <th> Action </th>
                          </tr>
                        </thead>

                        <tbody>
                          {challenge.map((game, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{game?._id}</td>
                              <td>
                                <span className="pl-2 ">
                                  {game.Created_by?.Name}
                                </span>
                              </td>

                              <td>
                                <span className="pl-2">
                                  {game.Accepetd_By
                                    ? game.Accepetd_By?.Name
                                    : null}
                                </span>
                              </td>
                              <td>{game.Game_Ammount}</td>

                              <td>
                                {game.Winner
                                  ? user?._id == game.Winner?._id
                                    ? "+" + game.winnAmount
                                    : "-" + game.Game_Ammount
                                  : user?._id == game.Created_by?._id
                                    ? game.winnAmount
                                    : "-" + game.winnAmount}
                              </td>

                              <td>
                                {game.Winner
                                  ? user?._id == game.Winner._id
                                    ? game.Winner_closingbalance
                                    : game.Loser_closingbalance
                                  : user._id == game.Created_by?._id
                                    ? game.Loser_closingbalance
                                    : game.Winner_closingbalance}
                              </td>
                              <td className="text-primary font-weight-bold">
                                {game.Status}
                              </td>
                              <td>{game.Game_type}</td>
                              <td>{game.Winner ? game.Winner.Name : null}</td>
                              <td>
                                {dateFormat(game.updatedAt).split(",")[0]}{" "}
                              </td>
                              <td>
                                <Link
                                  type="button"
                                  className="btn btn-primary mx-1"
                                  to={`/view/${game._id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(txn) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Status </th>
                            <th> Reason </th>
                            <th> Payment gatway </th>
                            <th> Action By </th>
                            <th>Created Date </th>
                            <th>Updated Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {txn.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>

                              <td>{data.amount}</td>
                              <td> {data.closing_balance}</td>

                              <td className="font-weight-bold text-success">
                                {data.status}
                              </td>
                              <td>{data.txn_msg}</td>

                              <td>
                                {" "}
                                {data.payment_gatway ? data.payment_gatway : ""}
                              </td>
                              <td>
                                {data?.action_by?.Name}
                              </td>
                              <td>
                                {dateFormat(data.createdAt).split(",")[0]}{" "}
                              </td>
                              <td>
                                {dateFormat(data.updatedAt).split(",")[0]}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(txnwith) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th> type</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Status </th>
                            <th> Reason </th>
                            <th> Action </th>
                            <th>Created Date </th>
                            <th>Updated Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {txnwith &&
                            txnwith.map((data, key) => (
                              <tr>
                                <td>{key + 1}</td>
                                <td>{data._id}</td>

                                <td>
                                  <span className="pl-2">
                                    {data.Withdraw_type}
                                  </span>
                                </td>
                                <td>{data.amount}</td>
                                <td> {data.closing_balance}</td>
                                <td className="font-weight-bold text-success">
                                  {data.status}
                                </td>
                                <td> {data.txn_msg}</td>
                                <td>
                                {data?.action_by?.Name}
                              </td>
                                <td>
                                  {dateFormat(data.createdAt).split(",")[0]}
                                </td>
                                <td>
                                  {dateFormat(data.updatedAt).split(",")[0]}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(referral) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Earned by</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {referral.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.earned_from.Name}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>
                                {dateFormat(data.updatedAt).split(",")[0]}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(bonus) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Action By</th>
                            <th> Reason</th>
                            <th> Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {bonus.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>{data.action_by?.Name}</td>
                              <td>{data?.txn_msg}</td>
                              <td>
                                {dateFormat(data.updatedAt).split(",")[0]}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(penalty) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Action By</th>
                            <th> Reason</th>
                            <th> Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {penalty.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>{data.action_by?.Name}</td>
                              <td>{data?.txn_msg}</td>
                              <td>
                                {dateFormat(data.updatedAt).split(",")[0]}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(kyc) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th>Doc name</th>
                            <th> Aadhar no</th>

                            <th>DOB</th>
                            <th> Document-Front</th>
                            <th> Document-Back</th>
                            <th> status </th>
                            <th>Date</th>
                            <th> Approve or Reject </th>
                            {/* <th> View </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {kyc &&
                            kyc.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item._id}</td>

                                <td>{item.Name}</td>

                                <td>{item.Number}</td>
                                <td>{item.DOB}</td>
                                <td>
                                  <div className="img-panel">
                                    <img
                                      className="img"
                                      src={baseUrl + `/${item.front}`}
                                      alt="kyc"
                                      style={{
                                        borderRadius: "5px",
                                        width: "4rem",
                                        height: "4rem",
                                      }}
                                      id={`kyc${index}`}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="img-panel">
                                    <img
                                      className="img"
                                      src={baseUrl + `/${item.back}`}
                                      alt="kyc"
                                      style={{
                                        borderRadius: "5px",
                                        width: "4rem",
                                        height: "4rem",
                                      }}
                                      id={`kyc${index}`}
                                    />
                                  </div>
                                </td>

                                <td>
                                  <span
                                    className={
                                      item.verified === "reject"
                                        ? "btn btn-danger"
                                        : "btn btn-success"
                                    }
                                  >
                                    {item.verified}
                                  </span>{" "}
                                </td>
                                <td>
                                  {dateFormat(item.updatedAt).split(",")[0]}{" "}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-success mr-1"
                                    disabled={
                                      item.verified === "verified"
                                        ? true
                                        : false
                                    }
                                    onClick={() => update(item._id)}
                                  >
                                    Approve
                                  </button>
                                  <button
                                    className="btn btn-danger"
                                    disabled={
                                      item.verified === "verified"
                                        ? false
                                        : false
                                    }
                                    onClick={() => deletedata(item._id)}
                                  >
                                    Reject
                                  </button>
                                </td>
                                {/* <td><Link to="/user/view" className="btn btn-primary">View</Link></td> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Refferal History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-5">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body text-light table_bg">
                  <h4 className="dashboard_heading">Refferal History</h4>
                  <select
                    className="form-control col-sm-1 m-1 bg-dark text-light"
                    id="pagelimit"
                    name="pagelimit"
                    onChange={setpageLimit}
                  >
                    <option value="10">Set limit</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                  </select>
                  <div className="table-responsive">
                    <table className="table ">
                      <thead>
                        <tr>
                          <th>#</th>

                          <th> Name</th>
                          <th> Number</th>
                        </tr>
                      </thead>

                      <tbody>
                        {user &&
                          user?.referral_user?.map((data, key) => (
                            <tr key={user._id}>
                              <td>{key + 1}</td>
                              <td>
                                <span
                                  className="badge badge-pill"
                                  style={{
                                    background: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => RefferalUser(data.id)}
                                >
                                  {data.Name}
                                </span>
                              </td>
                              {/* <td>{`${
                                "********" + data.Phone.toString().slice(-4)
                              }`}</td> */}
                              {userData == "Admin" ? (
                                <td className="text-success">{data.Phone}</td>
                              ) : (
                                <td className="text-success">{`${"********" + data.Phone.toString().slice(-2)
                                  }`}</td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-4">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showWithdraw} onHide={closeWithdraw}>
              <Modal.Header closeButton>
                <Modal.Title>Add Withdraw</Modal.Title>
              </Modal.Header>
                 <Modal.Body>
                <div className="form-group">
                  <label className="text-black">Withdraw Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={WithdrawAmount}
                    onChange={(e) => setWithdrawAmount(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="text-black">Reason</label>
                  <input
                    type="text"
                    className="form-control"
                    value={WithdrawReason}
                    onChange={(e) => setWithdrawReason(e.target.value)}
                  />
                </div>
             
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowWithdraw(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSaveWithdraw}>
                 Submit
                </Button>
              </Modal.Footer>
            </Modal>
    </>
  );
}
